import { inject } from '@angular/core';
import { TaApiService } from '@shared/services';
import { PERMISSIONS } from '@shared/constants';
import { TableConfig, PLACEHOLDER_FUNCTIONS } from '../generic-p-table.interfaces';

export const taTrainingTableConfig = (): TableConfig => {
  const taApiService = inject(TaApiService);

  return {
    title: 'Đào tạo trợ giảng',
    entityName: 'đào tạo trợ giảng',
    service: taApiService,
    method: 'getTaTrainings',
    columns: [
      { field: 'employee.code', header: 'Mã NV', width: 'min-w-[80px]', sortable: true, type: 'text'},
      { field: 'profile.fullname', header: 'Họ tên', width: 'min-w-[180px]', sortable: true, type: 'text'},
      { field: 'profile.nickname', header: 'Nickname', width: 'min-w-[150px]', sortable: true, type: 'text'},
      { field: 'type', header: 'Loại nhiệm vụ', width: 'min-w-[120px]', sortable: true, type: 'tag', tagType: 'taTaskType' },
      { field: 'courseLevel.name', header: 'Cấp độ', width: 'min-w-[100px]', sortable: true, type: 'tag', tagColor: 'courseLevel.tagColor', tagTextColor: 'courseLevel.tagTextColor' },
      { field: 'trainer', header: 'Trainer', width: 'min-w-[250px]', sortable: true, type: 'custom' },
      { field: 'deadline', header: 'Hạn chót', width: 'min-w-[120px]', sortable: true, type: 'date', dateFormat: 'dd/MM/yyyy' },
      { field: 'status', header: 'Trạng thái', width: 'min-w-[120px]', sortable: true, type: 'tag', tagType: 'trainingStatus' },
      { field: 'note', header: 'Ghi chú', width: 'min-w-[200px]', sortable: false, type: 'text' }
    ],
    features: {
      virtualScroll: true,
      toolbar: true,
    },
    actions: [
      {
        location: 'toolbar',
        useDefaultStyle: 'add',
        permission: PERMISSIONS.TA_EDIT.code,
        onClick: PLACEHOLDER_FUNCTIONS.OPEN_NEW
      },
      {
        location: 'row',
        useDefaultStyle: 'edit',
        permission: PERMISSIONS.TA_EDIT.code,
        onClick: PLACEHOLDER_FUNCTIONS.EDIT
      }
    ]
  };
};
